import React, { useState } from "react";
import { postRequest } from "../../utils/httpRequest";
import { t } from "../../utils/i18n";

const CreateSellWidget = ({}) => {
  const [submitting, setIsSubmitting] = useState(false);

  const onSubmit = (e: React.FormEvent) => {
    setIsSubmitting(true);

    postRequest("/api/v1/payment_methods/transak", {
      widget_type: "sell",
    })
      .then((response) => {
        window.open(response.widget_url, "_blank", "noopener,noreferrer");
        setIsSubmitting(false);
      })
      .catch((error) => {
        setIsSubmitting(false);
        console.log(error);
      });
  };

  return (
    <div className="add-funds-card bank">
      <div className="add-funds-card-content">
        <div className="top">
          <svg
            className="py-2"
            height="64px"
            width="64px"
            version="1.0"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 64 64"
            enableBackground="new 0 0 64 64"
            xmlSpace="preserve"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <g>
                {" "}
                <path
                  fill="#231F20"
                  d="M60,58c0-2.209-1.791-4-4-4h-2V25h6c1.795,0,3.369-1.194,3.852-2.922c0.484-1.728-0.242-3.566-1.775-4.497 l-28-17C33.439,0.193,32.719,0,32,0s-1.438,0.193-2.076,0.581l-28,17c-1.533,0.931-2.26,2.77-1.775,4.497 C0.632,23.806,2.207,25,4,25h6v29H8c-2.209,0-4,1.791-4,4c-2.209,0-4,1.791-4,4v2h64v-2C64,59.791,62.209,58,60,58z M52,54h-4V25h4 V54z M18,25h4v29h-4V25z M24,25h4v29h-4V25z M30,25h4v29h-4V25z M36,25h4v29h-4V25z M42,25h4v29h-4V25z M4,23 c-0.893,0-1.685-0.601-1.926-1.462c-0.241-0.859,0.124-1.784,0.888-2.247l28-17.001C31.275,2.1,31.635,2,32,2 c0.367,0,0.725,0.1,1.039,0.291l28,17c0.764,0.463,1.129,1.388,0.887,2.248C61.686,22.399,60.893,23,60,23H4z M12,25h4v29h-4V25z M8,56h48c1.105,0,2,0.896,2,2H6C6,56.896,6.896,56,8,56z M2,62c0-1.104,0.896-2,2-2h56c1.105,0,2,0.896,2,2H2z"
                ></path>
                <path
                  fill="#231F20"
                  d="M32,9c-2.762,0-5,2.238-5,5s2.238,5,5,5s5-2.238,5-5S34.762,9,32,9z M32,17c-1.656,0-3-1.343-3-3 s1.344-3,3-3c1.658,0,3,1.343,3,3S33.658,17,32,17z"
                ></path>{" "}
              </g>{" "}
            </g>
          </svg>

          <span className="badge badge-dark badge-pill">{t("wallets.transak.europe")}</span>
        </div>

        <div className="card-text">
          <h5 className="card-title">{t("wallets.transak.bank_transfer_europe")}</h5>

          <span>
            <small className="font-0_8">
              {t("wallets.transak.sell_crypto")}
            </small>
          </span>

          <div className="w-100 my-2 text-warning font-weight-bold">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-clock h-4 w-4"
              data-id="19"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>{" "}
            {t("wallets.transak.convenient_eu")}
          </div>

          <div className="w-full d-flex justify-content-start py-3 pl-3">
            <img
              src={require("../../../assets/images/fiat/sepa.png")}
              width={100}
              style={{
                marginTop: "15px",
                paddingLeft: "6px",
                paddingRight: "10px",
              }}
              alt="SEPA"
            />
          </div>

          <small>
            {t("wallets.transak.sell_info_1")}
            <br />
            {t("wallets.transak.sell_info_2")}
          </small>
        </div>
      </div>

      <div className="p-2 pb-3 card-fund-bottom">
        <div className="mt-2 pb-1 pt-3">
          <button
            className="btn btn-purple text-center w-100 rounded-lg"
            style={{ color: "white" }}
            disabled={submitting}
            onClick={(e) => onSubmit(e)}
          >
            {submitting ? (
              <>
                <i className="fa fa-circle-o-notch fa-spin"></i>
                <span style={{ paddingLeft: "5px" }}>
                  {t("wallets.transak.please_wait")}
                </span>
              </>
            ) : (
              <span>
                {t("wallets.transak.withdraw_by_selling")}{" "}
                <i className="fa fa-long-arrow-right ml-2" />
              </span>
            )}
          </button>

          <a
            className="text-muted d-flex justify-content-center align-items-center mt-2"
            href="https://www.bananacrystal.com/docs-category/withdrawing-your-funds/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <small>
              <i className="fa fa-info-circle mr-1"></i>
              {t("wallets.transak.how_to_use_banking")}
            </small>
          </a>
        </div>
      </div>
    </div>
  );
};

export default CreateSellWidget;
